import _ from 'underscore';
import moment from 'moment';
import ResourceOrder from 'common/enum/resource-order';

export const sort = {
  alphabetical(list, key) {
    if (key) {
      list.sort((datum1, datum2) => {
        if (datum1[key] < datum2[key]) {
          return -1;
        }
        if (datum1[key] > datum2[key]) {
          return 1;
        }
        return 0;
      });
    } else {
      list.sort((datum1, datum2) => {
        if (datum1 < datum2) {
          return -1;
        }
        if (datum1 > datum2) {
          return 1;
        }
        return 0;
      });
    }
    return list;
  },

  ascending(list, key) {
    if (key) {
      list.sort((datum1, datum2) => datum1[key] - datum2[key]);
    } else {
      list.sort((datum1, datum2) => datum1 - datum2);
    }
    return list;
  },

  descending(list, key) {
    if (key) {
      list.sort((datum1, datum2) => datum2[key] - datum1[key]);
    } else {
      list.sort((datum1, datum2) => datum2 - datum1);
    }
    return list;
  },

  resourcePrecedence: {
    list(listOfResources) {
      return _.sortBy(listOfResources, (resource) =>
        _.indexOf(ResourceOrder, resource),
      );
    },
    options(options) {
      return _.sortBy(options, (option) =>
        _.indexOf(ResourceOrder, option.value),
      );
    },
    key(list, key) {
      return _.sortBy(list, (object) => _.indexOf(ResourceOrder, object[key]));
    },
  },

  month: {
    key(list, key) {
      return _.sortBy(list, (object) =>
        _.indexOf(moment.months(), object[key]),
      );
    },
  },
};

/* Uses a Set to remove duplicates in an array while maintaining order */
export const stableDedupe = (array) => {
  const newArray = [];
  const seen = new Set();
  for (const item of array) {
    if (!seen.has(item)) {
      newArray.push(item);
      seen.add(item);
    }
  }
  return newArray;
};

export const swap = (arr, index1, index2) => {
  const temp = arr[index1];
  arr[index1] = arr[index2];
  arr[index2] = temp;
};

/* generator that cycles through array elements */
export const cycle = function* (arr) {
  while (true) yield* arr;
};
